export default "__VITE_ASSET__eef6bc8f__"